import { AGGREMENT_LIST, AGGREMENT_DETAIL } from "./actions";

const initialState = {
  aggrement: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  aggrementLoading: true,
  aggrementData: {},
};

const aggrementReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AGGREMENT_LIST:
      return {
        ...state,
        aggrement: payload,
        aggrementLoading: false,
      };
    case AGGREMENT_DETAIL:
      return {
        ...state,
        aggrementData: payload,
        aggrementLoading: false,
      };
    default:
      return state;
  }
};

export default aggrementReducer;
